import { useCallback, useState } from "react";

async function copyTextSafe(text) {
  try {
    // 1) 최신 Clipboard API
    if (
      typeof navigator !== "undefined" &&
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    // 2) 폴백: textarea + execCommand("copy")
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    textarea.style.top = "-9999px";

    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();

    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);

    return ok;
  } catch (e) {
    console.error("copyTextSafe error:", e);
    return false;
  }
}

export function useCopy() {
  const [isCopying, setIsCopying] = useState(false);
  const [error, setError] = useState(null);

  const copy = useCallback(async (text) => {
    setIsCopying(true);
    setError(null);
    try {
      const success = await copyTextSafe(text);
      if (!success) throw new Error("COPY_FAILED");
      return true;
    } catch (e) {
      setError(e);
      return false;
    } finally {
      setIsCopying(false);
    }
  }, []);

  return { copy, isCopying, error };
}
